/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('assets/glb-file/45.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    //actions[floating'].play();
    //actions['idle'].play();
    actions['dance'].play();
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="RootNode0" scale={0.01}>
          <group name="geo1">
            <skinnedMesh name="planet2" geometry={nodes.planet2.geometry} material={nodes.planet2.material} skeleton={nodes.planet2.skeleton} />
          </group>
          <group name="skeletal3">
            <primitive object={nodes.root4} />
          </group>
        </group>
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/45.glb')
